"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Button_1 = __importDefault(require("@cdo/apps/templates/Button"));
var ai_tutor_module_scss_1 = __importDefault(require("./ai-tutor.module.scss"));
var aiTutorRedux_1 = require("@cdo/apps/aiTutor/redux/aiTutorRedux");
var reduxHooks_1 = require("@cdo/apps/util/reduxHooks");
var react_redux_1 = require("react-redux");
/**
 * Renders the AI Tutor user chat message editor component.
 */
var UserChatMessageEditor = function () {
    var _a = (0, react_1.useState)(''), userMessage = _a[0], setUserMessage = _a[1];
    var isWaitingForChatResponse = (0, react_redux_1.useSelector)(function (state) { return state.aiTutor.isWaitingForChatResponse; });
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var handleSubmit = (0, react_1.useCallback)(function () {
        if (!isWaitingForChatResponse) {
            dispatch((0, aiTutorRedux_1.submitChatMessage)(userMessage));
            setUserMessage('');
        }
    }, [userMessage, dispatch, isWaitingForChatResponse]);
    return (react_1.default.createElement("div", { className: ai_tutor_module_scss_1.default.UserChatMessageEditor },
        react_1.default.createElement("textarea", { className: ai_tutor_module_scss_1.default.textArea, onChange: function (e) { return setUserMessage(e.target.value); }, value: userMessage }),
        react_1.default.createElement(Button_1.default, { key: "submit", text: "Submit", icon: "arrow-up", onClick: function () { return handleSubmit(); }, color: Button_1.default.ButtonColor.brandSecondaryDefault, disabled: isWaitingForChatResponse })));
};
exports.default = UserChatMessageEditor;
